import { render, staticRenderFns } from "./addOTAForm.vue?vue&type=template&id=5d07c2eb&scoped=true"
import script from "./addOTAForm.vue?vue&type=script&lang=js"
export * from "./addOTAForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07c2eb",
  null
  
)

export default component.exports